import React from 'react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-dark-primary py-16 border-t border-slate-800" data-id="element-12">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center text-center" data-id="element-13">
        <img src="https://cdn.magicpatterns.com/uploads/c2J7EfJRgjCnjErKDdmjhc/tmpu_weircg.webp" alt="OmniCredit Logo" className="h-10 object-contain mb-8 opacity-50 grayscale hover:grayscale-0 hover:opacity-100 transition-all duration-300" data-id="element-14" />

        <div className="max-w-4xl mx-auto space-y-4 text-xs sm:text-sm text-slate-500 leading-relaxed mb-8" data-id="element-15">
          <p data-id="element-16">
            La información contenida en este sitio web es solo información
            general y no constituye asesoramiento financiero o legal. Podemos
            recomendar un especialista para una evaluación de su situación
            particular. El uso, acceso o ingreso de información en nuestro sitio
            web no implica ni crea una relación vinculante, ni de manera
            explícita ni implícita.
          </p>
          <p data-id="element-17">
            Al enviar su información, usted está otorgando su consentimiento
            expreso "por escrito" para que los especialistas de OmniCredit lo
            contacten (mediante llamadas automáticas, mensajes de texto y
            mensajes pregrabados por conveniencia) a través de teléfono o
            dispositivo móvil (incluidos SMS y MMS; se pueden aplicar cargos de
            su operador, no por nosotros; la frecuencia de los mensajes varía;
            envíe HELP para obtener ayuda; envíe STOP para cancelar), incluso si
            su número de teléfono se encuentra actualmente en cualquier lista
            interna, corporativa, estatal o federal de No Llamar.
          </p>
        </div>

        <div className="text-xs text-slate-600 pt-8 border-t border-slate-800/50 w-full max-w-4xl" data-id="element-18">
          <p data-id="element-19">&copy; {currentYear} OmniCredit. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>;
}